<template>
  <div class="filter--mobile">
    <div class="title-row">
      <h5>{{ "filter.title.filter" | translate }}</h5>
      <i class="material-icons" @click="onCloseClick()">close</i>
    </div>
    <!-- selects -->
    <div class="select-container mobile-filter">
      <div v-for="(filter, i) in determineSelects" :key="i" class="filter-item">
        <gyra-filter
          :filter="filter"
          :allow-text-input="false"
          @input="onFilterChanged()"
        />
      </div>
    </div>

    <div class="toggle-row">
      <span>{{ "filter.title.sustainable" | translate }}</span>
      <toggle
        class="toggle"
        emoji="sustainable"
        label="product_map.sustainable"
        @input="onToggleChange"
        v-model="sustainable"
      ></toggle>
    </div>

    <div class="btn-container">
      <button class="white" @click="onApplyClick()">
        <span>{{ "filter.messages.reset" | translate }}</span>
      </button>
      <button class="apply-button" @click="onApplyClick()">
        <span>{{ "filter.messages.apply" | translate }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { filterMixin } from "../../mixins/filters/filterMixin";
import { filterModelMixin } from "../../mixins/filters/filterModelMixin";
import Toggle from "../atoms/toggle";
import GyraFilter from "./gyra-filter";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "filter-mobile",
  mixins: [filterMixin, filterModelMixin],
  components: { GyraFilter, Toggle },
  props: {
    includeTypeSelect: { type: Boolean, default: false }
  },
  methods: {
    onCloseClick() {
      this.$emit("close");
    },
    setSex($event) {
      this.resetCommons();
      this.sex = $event === "general.women" ? "women" : "men";
      this.setSelectOptions();
    },
    onApplyClick() {
      this.$emit("apply");
    },
    onFilterChanged() {
      this.$emit("filterChanged");
    },
    onToggleChange() {
      this.setSelectOptions();
    },
    ...mapMutations({
      resetCommons: "filters/resetCommons"
    })
  },
  computed: {
    determineSelects() {
      return this.includeTypeSelect ? this.selectsIncludingType : this.selects;
    },
    ...mapGetters({
      selectsIncludingType: "filters/getSelectsWithTypeSelect",
      selects: "filters/getSelects"
    })
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.filter--mobile {
  height: 100%;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: scroll;

  $filter-margins-left-right: 23px;

  .title-row {
    display: flex;
    background-color: black;
    flex-direction: row;
    justify-content: space-between;
    padding: 1.5rem;

    h5,
    .material-icons {
      color: white;
    }

    h5 {
      font-family: "Montserrat";
      font-weight: 700;
      font-size: $font-base;
      margin: 0;
    }
  }

  .apply-button {
    border: none;
    background-color: $brand-salmon;
  }

  .btn-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 1.5rem;
    background-color: $brand-black;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .toggle-row {
    padding: 1.5rem;
    display: flex;
  }
}

.filter-item--mobile {
  position: relative;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
}

.filter-item {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid $brand-black;
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.filter-item--mobile {
  .vs__dropdown-toggle {
    border: none;
  }

  .dropdown-toggle {
    border: none;
  }
  .dropdown-toggle::after {
    content: "";
  }
}
</style>
